document.addEventListener('DOMContentLoaded', function () {
  initProductSliders(document);
});

// Falls du im Theme Editor arbeitest: neu initialisieren, wenn eine Section geladen wird
document.addEventListener('shopify:section:load', function (event) {
  initProductSliders(event.target);
});

function initProductSliders(context) {
  // NUR normale Product Slider, NICHT unsere Custom-Image-Slider
  const containers = context.querySelectorAll(
    '.product-slider:not(.product-slider--custom-images) .product-slider__swiper'
  );

  containers.forEach(function (container) {
    // Wenn Swiper schon drauf ist, nicht nochmal initialisieren
    if (container.classList.contains('swiper-initialized')) return;

    const paginationEl = container.querySelector(
      '.swiper-pagination.product-slider__swiper-pagination'
    );

    const wrapper = container.closest('.product-slider');
    const useCustom = wrapper && wrapper.dataset.customWidth === 'true';

    const baseOptions = {
      loop: false,
      centeredSlides: false,
      pagination: {
        el: paginationEl,
        type: 'progressbar',
      },
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      watchOverflow: true,
    };

    // ---- Standardverhalten, exakt wie bisher ----
    const defaultOptions = {
      spaceBetween: 6,
      slidesPerView: 1.3,
      breakpoints: {
        500: { slidesPerView: 1.5, spaceBetween: 10 },
        600: { slidesPerView: 1.9, spaceBetween: 10 },
        800: { slidesPerView: 2.25, spaceBetween: 10 },
        900: { slidesPerView: 2.75, slidesOffsetAfter: 16, spaceBetween: 8 },
        1100: { slidesPerView: 3.25, slidesOffsetAfter: 16, spaceBetween: 8 },
        1200: { slidesPerView: 4.1, slidesOffsetAfter: 16, spaceBetween: 8 },
        1600: { slidesPerView: 4.9, slidesOffsetAfter: 16, spaceBetween: 8 },
      },
    };

    let options = defaultOptions;

    if (useCustom) {
      const d = wrapper.dataset;

      const num = function (value, fallback) {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? fallback : parsed;
      };

      const gapMobile = num(d.gapMobile, 6);
      const gapDesktop = num(d.gapDesktop, 10);

      options = {
        spaceBetween: gapMobile,
        slidesPerView: num(d.slidesXs, 1.3),
        breakpoints: {
          500: { slidesPerView: num(d.slidesSm, 1.5), spaceBetween: gapDesktop },
          600: { slidesPerView: num(d.slidesMd, 1.9), spaceBetween: gapDesktop },
          800: { slidesPerView: num(d.slidesLg, 2.25), spaceBetween: gapDesktop },
          900: { slidesPerView: num(d.slidesXl, 2.75), slidesOffsetAfter: 16, spaceBetween: gapDesktop },
          1100: { slidesPerView: num(d.slidesXxl, 3.25), slidesOffsetAfter: 16, spaceBetween: gapDesktop },
          1200: { slidesPerView: num(d.slidesXxxl, 4.1), slidesOffsetAfter: 16, spaceBetween: gapDesktop },
          1600: { slidesPerView: num(d.slidesWide, 4.9), slidesOffsetAfter: 16, spaceBetween: gapDesktop },
        },
      };
    }

    new Swiper(container, Object.assign({}, baseOptions, options));
  });
}